import React from 'react';
import { Text } from 'grommet';
import PropTypes from 'prop-types';

import Tooltip from 'granite-admin/core/components/Tooltip';
import InfoIcon from 'granite-admin/common/assets/InfoIcon';

const InfoText = ({ text, width = 'large', align }) => {
  const content = typeof text === 'string'
    ? <Text size="small" color="white">{text}</Text>
    : text;

  return (
    <Tooltip
      border={{ color: 'lightgray', size: 'xsmall' }}
      background="gray"
      width={width}
      align={align}
      content={content}
    >
      <InfoIcon />
    </Tooltip>
  );
};

InfoText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  width: PropTypes.string,
  align: PropTypes.string,
};

export default InfoText;
